import { useEffect, useRef, useState } from "react";
import { IPermission } from "../../../types/api";
import MidPopup from "../../../hoc/MidPopup/MidPopup";

import { toast } from "react-toastify";
import "./ExportStatisticsPopup.scss";

interface IChooseUserPopupProps {
  onClose: () => void;
  showPopup: boolean;
  onConfirm: (exportFileName: string) => void;
  presetFileName?: string;
  children?: React.ReactNode;
}
function ExportStatisticsPopup(props: IChooseUserPopupProps) {
  const { onClose, showPopup, onConfirm, children, presetFileName } = props;
  const [exportFileName, setExportFileName] = useState<string>(
    presetFileName || ""
  );
  const handleExportStatistics = () => {
    onConfirm(exportFileName);
    handleClose();
  };

  const handleClose = () => {
    setExportFileName("");
    onClose();
  };

  useEffect(() => {
    if (presetFileName) {
      setExportFileName(presetFileName);
    }
  }, [presetFileName]);

  return (
    <MidPopup
      onClose={handleClose}
      showPopup={showPopup}
      leftTopElement={<span className="text-m">Export inställningar</span>}
      onConfirm={() => {
        if (true) {
        }
      }}
    >
      <div className="export-statistics-popup-wrapper">
        {children}
        <div className="export-statistics-wrapper">
          <label className="text-m" htmlFor="exportFileName">
            Filnamn för export:
          </label>
          <input
            className="text-m"
            type="text"
            id="exportFileName"
            value={exportFileName}
            onChange={(e) => setExportFileName(e.target.value)}
            placeholder="Ange filnamn"
          />
        </div>
        <div className="export-statistics-btns-wrapper">
          <button
            className="btn btn-primary text-m"
            onClick={() => handleExportStatistics()}
            disabled={exportFileName.trim() === ""}
          >
            Exportera
          </button>
        </div>
      </div>
    </MidPopup>
  );
}

export default ExportStatisticsPopup;
